import { Check } from "components/common/Icons";
import { useDebateContext } from "contexts/DebateContext";
import { TYPO } from "styles/Typo";

function DebateSetting({}: {}) {
  const { sort, setSort, setIsCleanMode, isCleanMode } = useDebateContext();

  return (
    <div className="py-2 px-6  bg-white flex items-center justify-between">
      <div
        className="flex items-center cursor-pointer "
        onClick={() => {
          if (sort === "new") setSort("like");
          else setSort("new");
        }}
        data-gtm-id={`report-sort-button`}
      >
        <span className={`${TYPO.TYPO6_MD} text-gray60`}>
          {sort === "new" ? "최신순" : "인기순"}
        </span>
        <SortIcon />
      </div>
      <div
        className="flex items-center cursor-pointer "
        onClick={() => {
          console.log("부적절한 글 숨기기");
          setIsCleanMode((prev: boolean) => !prev);
        }}
        data-gtm-id={`report-clean-mode-button`}
      >
        <Check
          fill={isCleanMode ? "blue40" : "gray30"}
          height={24}
          width={24}
        />
        <span
          className={`${TYPO.TYPO6_RG}  ${
            isCleanMode ? "text-blue40" : "text-gray50"
          }`}
        >
          {"부적절한 글 숨기기"}
        </span>
      </div>
    </div>
  );
}

const SortIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.5 9.5L8 6L11.5 9.5"
        stroke="var(--gray30)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 15L16 18.5L12.5 15"
        stroke="var(--gray30)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 18.5V6"
        stroke="var(--gray30)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6L16 18.5"
        stroke="var(--gray30)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DebateSetting;
